import { dataHooks } from '@wix/data-hooks';

export const visitorPageMediaDataHooks = dataHooks<{
  desktopMedia;
  mobileMedia;
}>('visitor-page-media');
